import { Box, Button, Card, Skeleton, Typography } from '@mui/material';
import Label from './Label.tsx';
import HeaderStudio from './HeaderStudio.tsx';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { IPackage } from '../../interfaces/studio.ts';
import { ChevronLeft, ChevronLeftRounded } from '@mui/icons-material';
import numberFormat from '../../utils/numberFormat.ts';
import PackageItem from '../common/PackageItem.tsx';
import Grid from '@mui/material/Unstable_Grid2';

interface ITeammates {
	company_title: string;
	id: number;
	image: string;
	price: string;
	title: string;
}

interface ICombined extends IPackage {
	teammates: ITeammates[]; // An array of ITeammates
}

export default function Detail() {
	const { t } = useTranslation();

	const { id } = useParams();

	const [data, setData] = useState<ICombined>();

	useEffect(() => {
		axios({
			method: 'get',
			url: `studio/showPackage/${id}`,
		}).then(r => {
			if (r?.data?.success) {
				setData(r?.data?.data);
			}
		});
	}, [id]);

	return (
		<Box className={'flex w-full flex-col gap-6'}>
			<HeaderStudio data={data} />

			<Card className={'flex flex-col gap-6 p-6'}>
				<Box className={'flex w-full items-start gap-6'}>
					<Box className={'flex basis-2/12'}>
						<Label text={t('rules_and_regulations')} />
					</Box>
					<Box className={'flex basis-10/12'}>{data === undefined ? <Skeleton className={'w-full'} /> : <Typography className={'text-sm text-text-secondary'}>{data?.rules}</Typography>}</Box>
				</Box>
			</Card>
			<Card>
				<Box className="flex items-center justify-between p-6">
					<Box className="flex items-center gap-6">
						<Label text={t('construction_cost')} />
						<Box className={'flex items-center'}>
							{data === undefined ? (
								<Skeleton className={'w-full'} />
							) : (
								<>
									<Typography className={'text-xl'}>{numberFormat(+data?.price)}</Typography>
									<Typography className={'ms-1 text-xl text-text-secondary'}>{t('tooman')}</Typography>
								</>
							)}
						</Box>
					</Box>
					<Button variant={'contained'} component={Link} to={`/studio/create/${id}`} endIcon={<ChevronLeft />} disabled={!data} className={'h-10 w-32 md:h-12 md:w-52'}>
						{t('order_registration')}
					</Button>
				</Box>
			</Card>

			{(data?.teammates?.length ?? 0) > 1 && (
				<Card className={'px-6 pb-8 pt-4'}>
					<Box className={'mb-6 flex justify-between'}>
						<Typography className={'text-2xl font-medium'}>{t('post_slide_instagram')}</Typography>
						{(data?.teammates?.length ?? 0) > 3 && (
							<Button variant={'text'} endIcon={<ChevronLeftRounded />} color={'primary'} component={Link} to={`/studio/detail/${id}/similar`}>
								{t('see-more')}
							</Button>
						)}
					</Box>
					<Grid container spacing={2}>
						{data?.teammates?.slice(0, 3)?.map(i => (
							<Grid key={i?.id} sm={6} md={4}>
								<PackageItem title={i?.title ?? ''} price={+(i?.price ?? 0)} link={`/studio/detail/${i?.id}`} image={i?.image} />
							</Grid>
						))}
					</Grid>
				</Card>
			)}
		</Box>
	);
}
